import { PageHeader } from '@/components/shared/page-header';
import { useCreatePurchaseOrder } from '@/hooks/use-purchase-orders';
import { useLocationStore } from '@/stores/location-store';
import { toast } from '@/stores/toast-store';
import { PurchaseOrderForm } from './purchase-order-form';

export function PurchaseOrderCreatePage() {
  const createPO = useCreatePurchaseOrder();
  const { selectedLocationId } = useLocationStore();

  const handleSubmit = async (data: any) => {
    const result: any = await createPO.mutateAsync(data);
    const po = result?.data;
    const orderNumber = po?.orderNumber ?? '';
    const invoiceNo = po?.payeeInvoiceNo ?? '';
    const ref = orderNumber ? `#${orderNumber}` : invoiceNo ? `(${invoiceNo})` : '';
    // POs now save as draft — explicit "Send to Vendor" action is required to
    // notify. Tell the user the next step instead of implying the email went.
    toast.success(`Purchase order ${ref} saved as draft. Click "Send" on the list to notify the vendor.`);
    window.location.hash = '#/pos-management?tab=purchase-orders';
  };

  return (
    <div className="space-y-4">
      <PageHeader title="Create Purchase Order" backTo="#/pos-management?tab=purchase-orders" />
      <PurchaseOrderForm
        onSubmit={handleSubmit}
        isSubmitting={createPO.isPending}
        defaultLocationId={selectedLocationId}
      />
    </div>
  );
}
